import { Modal as AntModal } from 'antd';
import styles from './modal.module.scss';
import { Button } from '../button/button';

type ModalProps = {
  onCancel: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
  isExporting?: boolean;
};

export function Modal({ onCancel, onConfirm, isOpen, isExporting, title, children }: ModalProps) {
  return (
    <AntModal
      className={styles.modal}
      title={title}
      open={isOpen}
      onOk={onConfirm}
      onCancel={onCancel}
      footer={
        <div className={styles.footer}>
          <Button buttonVariant="secondary" className={styles.modalButton} onClick={onCancel}>
            Close
          </Button>
          <Button
            loading={isExporting}
            buttonVariant="primary"
            className={styles.modalButton}
            onClick={onConfirm}
          >
            Export
          </Button>
        </div>
      }
    >
      {children}
    </AntModal>
  );
}
